import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { CarouselItem } from './../../../../../components/carousel/carousel.service';
import { RoutingService } from '../../../../../services/routing/routing.service';
import { AnalyticsService } from '../../../../../services/analytics/analytics.service';

@Component({
  selector: 'ag-clcd-books-like-this',
  templateUrl: './books-like-this.component.html',
  styleUrls: ['./books-like-this.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BooksLikeThisComponent {
  @Input() carouselItems: CarouselItem[];
  @Input() slideCounts: number;

  private _routingService = inject(RoutingService);
  private _analyticService = inject(AnalyticsService);

  goToFullRecord(carouselItem: CarouselItem) {
    this._analyticService.logEvent('Books Like This');
    this._routingService.goToFullRecordByAgControlId(
      carouselItem.agControlId,
      carouselItem.libraryDbPoolKey,
    );
  }
}
